// @system — copy for the admin area that ships with the template: the Staff & roles page
// (/app/admin/staff) and the access-denied screen ProtectedRoute renders when a permission is
// missing. Read as text.admin.*; products override keys in @custom/text (deep-merged).
// `{name}` placeholders are filled with tpl() where the string is used.
export const admin = {
  common: {
    save: 'Save',
    close: 'Close',
    retry: 'Retry',
    search: 'Search',
    loadError: 'Something went wrong while loading this page.',
    noResults: 'No results',
    noResultsHint: 'Try adjusting your search.',
    adminOverview: 'Admin',
  },
  access: {
    deniedTitle: 'You do not have access to this page',
    deniedBody: 'Your role does not include the permission this page requires. Ask an owner or administrator to grant it on the Staff & roles page.',
    requires: 'Requires',
    backHome: 'Back to home',
  },
  staff: {
    title: 'Staff & roles',
    description: 'Who can enter the admin area and what each role may do.',
    members: 'Staff members',
    membersDescription: 'Everyone holding an admin role. Regular members are not listed.',
    searchPlaceholder: 'Search staff by name or email',
    columns: { member: 'Member', role: 'Role', joined: 'Joined', lastSeen: 'Last seen' },
    never: 'Never',
    you: 'You',
    roleChanged: 'Role updated',
    roleChangeFailed: 'Could not change role',
    ownRoleLocked: 'You cannot change your own role.',
    ownerLocked: 'Only an owner can assign or remove the owner role.',
    empty: 'No staff yet',
    emptyHint: 'Promote an existing account below to give it an admin role.',
    add: {
      title: 'Add staff member',
      description: 'Find an existing account by email, then pick a role. The person must have signed up first.',
      email: 'Account email',
      lookup: 'Find account',
      notFound: 'No account with that email',
      found: 'Account found',
      alreadyStaff: 'This account already holds an admin role. Change it in the table above.',
      role: 'Role',
      assign: 'Assign role',
      assigned: 'Role assigned',
    },
    matrix: {
      title: 'Permission matrix',
      description: 'Tick what each role may do. Owners always hold every permission.',
      permission: 'Permission',
      members: '{count} members',
      member: '1 member',
      save: 'Save {role}',
      saved: 'Permissions saved for {role}',
      saveFailed: 'Could not save permissions',
      ownerLocked: 'The owner role always holds every permission.',
      defaultsNote: 'Showing template defaults: the database matrix is not loaded yet.',
      readOnlyNote: 'You can see the matrix but only roles with staff.manage can edit it.',
      groups: {
        platform: 'Platform',
        users: 'Users',
        billing: 'Billing',
        content: 'Content',
        staff: 'Staff',
      },
    },
  },
}
